module.exports = __webpack_public_path__ + "static/media/img-manager-small.3569ddc4.png";